export default "__VITE_ASSET__Bns7w8at__"